import './css/BrandAndStore.css'

import React, { useEffect, useState, } from 'react'
import { useParams } from "react-router-dom"
import { Map } from '@uiw/react-amap';
import { Form, Button, Modal, Input, Select, TimePicker, DatePicker, Cascader, Upload, message, Space, Row, Col } from 'antd'
import { LoadingOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons'
import { axiosHandleEvent, axiosTable } from '../../tool/axios'
import { ngetBase64 } from '../../js/globalParam'
import { apiPrefix } from '../../js/config'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'
import moment from 'moment';
import E from 'wangeditor'
import _ from 'lodash'

declare global {
    interface Window { AMapUI: any; }
}

const AMapUI = window.AMapUI || {};
const AMap = window.AMap;

const { Option } = Select
const { RangePicker } = TimePicker

const dateFormat = 'YYYY-MM-DD';
const timeFormat = 'HH:mm:ss';

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'

    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
        message.error('上传图片不能大于3MB!')
    }

    return isJpgOrPng && isLt3M
}

export default function AddBrand() {

    const [brandInfo, setBrandCode] = useState<any>({})
    const [loading, setLoading] = useState<boolean>(false)

    const [editor, setEditor] = useState<null | E>(null)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editorVisible, setEditorVisible] = useState(false);

    const [show, setShow] = useState(false);
    const [previewImage, setPreviewImage] = useState<string>('')
    const [visible, setVisible] = useState<boolean>(false)
    const [formInstance] = Form.useForm()

    const [response, setResponse] = useState<any>({})
    const [storageLocal, setStorageLocal] = useState<any>({})
    const [defaultLocal, setDefaultLocal] = useState<any[]>()

    const [flagOption, setFlagOption] = useState<any>({})
    const [options, setOptions] = React.useState([]);
    const [brand, setBrand] = useState<any[]>([])
    const [pool, setPool] = useState<any[]>([])

    let { id }: { id: string } = useParams()

    useEffect(() => {
        getBrandList()
        getPoolList()

        if (id) {
            axiosTable.get("/manage_center/store/detail", { params: { id } }).then((r: any) => {
                let result = _.cloneDeep(r)

                result.store_logo_url = [{ id: '', response: { data: [result.store_logo_url] }, url: result.store_logo_url }]
                result.store_pic_vedios = result.store_pic_vedios.map((el: { file_url: string, id: string }) => ({
                    url: el.file_url, id: el.id, uid: Math.random(),
                    response: { data: [el.file_url] }
                }))

                result.store_indro = Base64.fromBase64(result.store_indro)
                result.new_store_flag = result.store_flag.split(',').reduce((acc: Array<any>, item: any) => {
                    let obj = {
                        value: item.split('&&&')[0],
                        color: item.split('&&&')[1]
                    }

                    acc.push(obj)
                    return acc
                }, [])

                result.store_flag = result.new_store_flag.reduce((acc: Array<any>, item: any) => {
                    acc.push(item.value)
                    return acc
                }, [])

                result['range-time-picker'] = [moment(result.start_business, timeFormat), moment(result.end_business, timeFormat)]
                result['open_time'] = moment(result.open_time)

                let arr = [result.province_name, result.city_name, result.area_name, result.street_name]
                result.area = arr
                setDefaultLocal(arr)

                result.isSelectLocal = true;
                setResponse(result)
                setFlagOption({ values: result.store_flag })

                let targetOption: any = [];

                axiosTable.get("/global/province_list", { params: {} }).then((res: any) => {
                    for (let i of res) {
                        i.type = 'province';
                        i.name = i.province_name;
                        i.short_name = i.short_name;
                        i.code = i.province_code;
                        i.isLeaf = false;
                    }

                    targetOption = res

                }).then(() => {
                    axiosTable.get("/global/city_list", { params: { province_code: result.province_code } }).then((res: any) => {
                        for (let i of res) {
                            i.type = 'city';
                            i.name = i.city_name;
                            i.code = i.city_code;
                            i.isLeaf = false;
                        }

                        for (let i of targetOption) {
                            if (i.province_code == result.province_code) {
                                i.children = res;
                            }
                        }

                    }).then(() => {
                        axiosTable.get("/global/area_list", { params: { city_code: result.city_code } }).then((res: any) => {
                            for (let i of res) {
                                i.type = 'area';
                                i.name = i.area_name;
                                i.code = i.area_code;
                                i.isLeaf = false;
                            }

                            for (let i of targetOption) {
                                if (i.province_code == result.province_code) {
                                    for (let b of i.children) {
                                        if (result.city_code == b.city_code) {
                                            b.children = res;
                                        }
                                    }
                                }
                            }
                        })

                    }).then(() => {
                        axiosTable.get("/global/street_list", { params: { area_code: result.area_code } }).then((res: any) => {
                            for (let i of res) {
                                i.type = 'street';
                                i.name = i.street_name;
                                i.code = i.street_code;
                            }

                            for (let i of targetOption) {
                                if (i.province_code == result.province_code) {
                                    for (let b of i.children) {
                                        if (result.city_code == b.city_code) {
                                            for (let c of b.children) {
                                                if (result.area_code == c.area_code) {
                                                    c.children = res;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            setOptions(targetOption)
                            setShow(true)
                        })
                    })
                })

                formInstance.setFieldsValue(result)
            })

        } else {
            getProvince()
            setShow(true)
        }
    }, [])

    useEffect(() => {
        if (isModalVisible) {
            AMapUI.loadUI(['misc/PositionPicker'], function (PositionPicker: any) {
                let center: any = [];

                if (response.lng && response.lat) {
                    center = [response.lng, response.lat]

                } else {
                    center = ""
                }

                var map: any = new AMap.Map('container', {
                    zoom: 16,
                    center
                })

                var positionPicker: any = new PositionPicker({
                    mode: 'dragMap',
                    map: map
                });

                positionPicker.on('success', function (positionResult: any) {
                    let regeo: any = positionResult.regeocode.pois[0];
                    let position: any = positionResult.position;

                    storageLocal.detail_address = regeo.name
                    storageLocal.lng = position.lng
                    storageLocal.lat = position.lat

                    setStorageLocal(storageLocal)

                });

                positionPicker.start();
                map.panBy(0, 1);
            })
        }
    }, [isModalVisible])

    useEffect(() => {
        if (editorVisible && editor === null) {
            const editor: any = new E('.add-editor')
            editor.config.uploadFileName = "files"
            editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'
            editor.config.uploadImgParams = {
                fileType: 1,
                bucketType: 4
            }

            editor.config.uploadImgHeaders = {
                token: Cookies.get('token')
            }

            editor.config.uploadImgHooks = {
                // 例如，服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
                customInsert: function (insertImgFn: any, result: any) {
                    // result 即服务端返回的接口
                    insertImgFn(result.data[0])
                }
            }
            editor.create()

            setEditor(editor)
            setTimeout(() => { editor?.txt.html(formInstance.getFieldValue('store_indro')) }, 200)
        }
    }, [editorVisible])

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const getBrandList = () => {
        axiosTable.get('/manage_center/brand/list', {

        }).then((response: any) => {
            setBrand(response)
        })
    }

    const getPoolList = () => {
        axiosTable.get('/manage_center/flag/list', {
            params: {
                flag_type: 2
            }

        }).then((response: any) => {
            setPool(response)
        })
    }

    const getProvince = () => {
        axiosTable.get("/global/province_list", { params: {} }).then((res: any) => {
            for (let i of res) {
                i.type = 'province';
                i.name = i.province_name;
                i.short_name = i.short_name;
                i.code = i.province_code;
                i.isLeaf = false;
            }

            setOptions(res)
        })
    }

    const handleSelectChange = (values: any, options: any) => {
        if (options.length > 3) {
            message.error("最多选择3个")
            values.pop()

            formInstance.setFieldsValue({
                store_flag: values
            })

            return;
        }

        let newOptions = {
            options,
            values
        }

        setFlagOption(newOptions)
    }

    const handleModalOk = () => {
        let html = editor?.txt.html()
        formInstance.setFieldsValue({ store_indro: html })

        setEditorVisible(false)
    }

    const onFinish = (values: any) => {
        let url: string = '';
        let signFlag: any = '';

        values = Object.assign(response, values)
        values.open_time = values['open_time'].format(dateFormat);
        values.start_business = values['range-time-picker'][0].format(timeFormat);
        values.end_business = values['range-time-picker'][1].format(timeFormat);
        values.complete_address = `${values.province_name}${values.city_name}${values.area_name}${values.street_name}${values.detail_address}`;

        if (id) {
            // 用户未触发变更
            if (flagOption.options == undefined) {
                signFlag = response.new_store_flag;

            } else {
                for (let b of flagOption.options) {
                    for (let i of response.new_store_flag) {
                        if (i.value == b.value) {
                            b.color = i.color;
                        }
                    }
                }

                signFlag = flagOption.options
            }

        } else {
            signFlag = flagOption.options
        }

        signFlag = signFlag.reduce((acc: any, item: any) => {
            acc += `${item.value}&&&${item.color},`
            return acc
        }, '')

        values.store_flag = signFlag.substring(0, signFlag.length - 1)
        values.store_logo_url = values.store_logo_url[0].response.data[0]

        values.store_pic_vedios = values.store_pic_vedios.reduce((acc: any, item: any) => {
            let obj: any = {
                "file_url": item.response.data[0]
            }

            if (item.id) {
                obj.id = item.id;
            }

            acc.push(obj)
            return acc
        }, [])

        url = id ? '/manage_center/store/update' : '/manage_center/store/add';

        let resultValue: any = {
            id: '',
            store_name: '',
            tenant_brand_list_id: '',
            store_status: '',
            contact_phone: '',
            start_business: '',
            end_business: '',
            open_time: '',
            province_code: '',
            province_name: '',
            city_code: '',
            city_name: '',
            area_code: '',
            area_name: '',
            street_code: '',
            street_name: '',
            detail_address: '',
            store_logo_url: '',
            store_pic_vedios: '',
            store_flag: '',
            store_indro: '',
            complete_address: '',
            lng: '',
            lat: ''
        }

        if (id) {
            resultValue.id = id;
        }

        for (let i in resultValue) {
            resultValue[i] = values[i]
        }

        axiosHandleEvent.post(url, { ...values }).then((res: any) => {
        })
    }

    const showEditModal = () => {
        setEditorVisible(true)
        editor?.txt.html(formInstance.getFieldValue('store_indro'))
    }

    const onChange = (value: any, selectedOptions: any) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        const nresponse: any = _.cloneDeep(response);

        if (selectedOptions.length == 4) {
            response.province_code = selectedOptions[0].province_code;
            response.province_name = selectedOptions[0].province_name;
            response.city_code = selectedOptions[1].city_code;
            response.city_name = selectedOptions[1].city_name;
            response.area_code = selectedOptions[2].area_code;
            response.area_name = selectedOptions[2].area_name;
            response.street_code = selectedOptions[3].street_code;
            response.street_name = selectedOptions[3].street_name;
            response.lng = targetOption.lng;
            response.lat = targetOption.lat;
            response.isSelectLocal = true;
            response.detail_address = null;

            setResponse(response)

        } else {
            nresponse.isSelectLocal = false;
            nresponse.lng = ''
            nresponse.lat = ''
            nresponse.detail_address = null

            setResponse(nresponse)
        }
    };

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }

        setPreviewImage(file.preview)
        setVisible(true)
    }

    const loadData = (selectedOptions: any) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;

        // 省的情况
        if (targetOption.type == "province") {
            axiosTable.get("/global/city_list", { params: { province_code: targetOption.code } }).then((res: any) => {
                targetOption.loading = false

                for (let i of res) {
                    i.type = 'city';
                    i.name = i.city_name;
                    i.code = i.city_code;
                    i.isLeaf = false;
                }

                targetOption.children = res;
                setOptions([...options]);
            })

        } else if (targetOption.type == "city") {
            axiosTable.get("/global/area_list", { params: { city_code: targetOption.code } }).then((res: any) => {
                targetOption.loading = false

                for (let i of res) {
                    i.type = 'area';
                    i.name = i.area_name;
                    i.code = i.area_code;
                    i.isLeaf = false;
                }

                targetOption.children = res;
                setOptions([...options]);
            })

        } else {
            axiosTable.get("/global/street_list", { params: { area_code: targetOption.code } }).then((res: any) => {
                targetOption.loading = false

                for (let i of res) {
                    i.type = 'street';
                    i.name = i.street_name;
                    i.code = i.street_code;
                }

                targetOption.children = res;
                setOptions([...options]);
            })
        }
    };

    const asd = (e: any) => {

    }

    const handleOk = (e: any) => {
        response.detail_address = storageLocal.detail_address
        response.lng = storageLocal.lng
        response.lat = storageLocal.lat

        setResponse(response)
        setIsModalVisible(false)
    }

    const showMap = () => {
        if (!response.isSelectLocal) {
            message.error('请选择所属区域精细到街道')
            return;
        }

        setIsModalVisible(true)
    }

    const brandChange = (e: any, options: any) => {
        setBrandCode(options)
    }

    const myStatus: any = [{ id: 1, name: '启用' }, { id: 2, name: '关闭' }]
    const isBaseStore: any = [{ id: 0, name: '不是' }, { id: 1, name: '是' }]

    return (<div className="common-level2-edit">
        <h2>{id ? '编辑' : '新增'}门店</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} onFinish={onFinish} >
                <Form.Item label="门店名称" name="store_name" rules={[{ required: true, message: '必须输入门店名称' }, () => ({
                    validator(_, value) {
                        if (!/\s/.test(value)) {
                            return Promise.resolve();
                        }

                        return Promise.reject(new Error('不能输入空格'));
                    },
                })]}>
                    <Input placeholder="请输入门店名称" />
                </Form.Item>

                <Form.Item label="所属品牌" name="tenant_brand_list_id" rules={[{ required: true, message: '必须选择所属品牌' }]}>
                    <Select allowClear={true} style={{ width: 160 }} placeholder="选择所属品牌" onChange={brandChange}>
                        {brand.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.brand_name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="门店标签" name="store_flag" rules={[{ required: true, message: '必须选择门店标签' }]}>
                    <Select
                        mode="multiple"
                        value={flagOption.values}
                        placeholder="请选择门店标签"
                        onChange={handleSelectChange}
                        style={{ width: '100%' }}
                    >
                        {pool.map((item: any) => {
                            return <Option value={item.label_name} color={item.label_color} key={item.id} >{item.label_name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="门店电话" name="contact_phone" rules={[{ required: true, message: '必须输入门店电话' }, () => ({
                    validator(_, value) {
                        if (/^\d(?!(\d*-\d*){20}$)(\d|-){1,20}\d$/.test(value) || !value) {
                            return Promise.resolve();
                        }

                        return Promise.reject(new Error('不能输入空格、英文、汉字'));
                    },
                })]}>
                    <Input placeholder="请输入门店电话" />
                </Form.Item>

                <Form.Item label="开业时间" name="open_time" rules={[{ required: true, message: '必须选择开业时间' }]}>
                    <DatePicker format={dateFormat} />
                </Form.Item>

                <Form.Item label="营业时间" name="range-time-picker" rules={[{ required: true, message: '必须选择营业时间' }]}>
                    <RangePicker onChange={asd} format={timeFormat} />
                </Form.Item>

                <Form.Item rules={[{ required: true, message: '必须上传门店封面图' }]}
                    name="store_logo_url"
                    label="门店封面图"
                    valuePropName="fileList"
                    extra="（大小不超过3M）"
                    getValueFromEvent={uploadFile}
                >
                    <Upload
                        maxCount={1}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item
                    name="store_pic_vedios" rules={[{ required: true, message: '必须上传门店轮播图' }]}
                    label="门店轮播图"
                    valuePropName="fileList"
                    extra="（最多可上传6张，大小不超过3M）"
                    getValueFromEvent={uploadFile}
                >
                    <Upload
                        maxCount={6}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                {show ?
                    <Form.Item label="门店区域" name="area" rules={[{ required: true, message: '必须选择门店区域' }]}>
                        <Cascader defaultValue={defaultLocal} options={options} fieldNames={{ label: 'name', value: 'name' }} loadData={loadData} onChange={onChange} changeOnSelect />
                    </Form.Item>
                    : ''
                }

                <Form.Item label="详细地址">
                    <div className="peng-div-area" onClick={showMap} style={{ cursor: 'auto', color: response.detail_address ? '#000' : 'rgb(191,191,191)' }}>{response.detail_address ? response.detail_address : '请选择详细地址'}</div>
                </Form.Item>

                <Form.Item label="是否总部店" name="is_base_store" rules={[{ required: true, message: '必须选择是否总部店' }]}>
                    <Select style={{ width: 160 }} placeholder="请选择是否总部店">
                        {isBaseStore.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="门店状态" name="store_status" rules={[{ required: true, message: '必须选择门店状态' }]}>
                    <Select style={{ width: 160 }} placeholder="请选择门店状态">
                        {myStatus.map((item: any) => {
                            return <Option value={item.id} key={item.id}>{item.name}</Option>
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="门店简介" name="store_indro" rules={[{ required: true, message: '必须填写门店简介' }]}>
                    <Button onClick={showEditModal} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal title="门店简介" visible={editorVisible} onCancel={() => { setEditorVisible(false); }} width="800px" onOk={handleModalOk}>
            <div className="add-editor"></div>
        </Modal>

        <Modal title="选择地址" width={700} onOk={handleOk} visible={isModalVisible} onCancel={() => { setIsModalVisible(false) }}>
            <div id="container" style={{ width: '100%', height: '500px' }}></div>
        </Modal>

        <Modal
            visible={visible}
            title='浏览图片'
            footer={null}
            onCancel={() => { setVisible(false) }}
        >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
    </div >
    )
}